import { render, staticRenderFns } from "./ChannelOne.vue?vue&type=template&id=1c74cbaf&scoped=true"
import script from "./ChannelOne.vue?vue&type=script&lang=js"
export * from "./ChannelOne.vue?vue&type=script&lang=js"
import style0 from "./ChannelOne.vue?vue&type=style&index=0&id=1c74cbaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74cbaf",
  null
  
)

export default component.exports